import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { NavigationGroupEntrySchema } from './navigation-group.validator';
import { NavigationItemEntrySchema } from './navigation-item.validator';

export const NavigationDropdownEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    label: z.string(),
    icon: z.string().optional().nullable(),
    items: z.array(z.union([NavigationGroupEntrySchema, NavigationItemEntrySchema])),
    accessType: z
      .array(z.enum(['Customer', 'Guest', 'Internal', 'Pending', 'Public']))
      .optional()
      .nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
